if ($('#app-ratings-radio-market-comp').length) {
    var form_markets;

    var form_curr_market;
    var form_curr_books;
    var form_curr_book_limit;
    var form_curr_stations;
    var form_curr_area = 'Metro';
    var market_type;
    var hide_one;
    var hide_two;

    var chart_stations=[];
    $('#custom_chart').on('click', function () {
        var html_type= ' <option value=""></option>' +
            '                                            <option value="pie">Pie</option>' +
            '                                            <option value="column">Column (Vertical)</option>' +
            '                                            <option value="bar">Column (Horizontal)</option>';

        $('#chart_type').select2({
            minimumResultsForSearch: 5,
            placeholder: 'Select one....',
        });
        $('#chart_type').html(html_type);
        $('#chart_data_type').select2({
            minimumResultsForSearch: 5
        });
        $('#chart_demo_options').select2({
            placeholder: "Select at least one..",
            closeOnSelect: false,
            placeholder: 'Select at least one....',
        });

        var table=   $('#ratings_radio_market_comp_table ').DataTable();
        console.log('table',table);
        var ages=[];

         if( market_type !== 'PPM')
            ages= [ '12-17', '18-24', '25-34', '50-54', '45-54', '55-64', '65+'];
         else
             ages= ['6-11','12-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'];

        $('#chart_age').multiSelect({
            selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_dayparts'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_dayparts'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
            afterInit: function (ms) {
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function (e) {
                        if (e.which === 40) {
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function (values) {
                this.qs1.cache();
            },
            afterDeselect: function (values) {
                this.qs1.cache();
            }
        });
        var html = '';
        for(var i in ages)
            html +='<option value="'+ages[i]+'">'+ages[i]+'</option>';
        $('#chart_age').html(html).multiSelect('refresh');
        $('#chart_stations').multiSelect({
            selectableHeader: "<input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: "<div class='' style='height: 38px;'><div class='btn-group' role='group'><button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' id='sel_all_chart_sta'><i class='fa fa-link fa-fw'></i>  Select All</button>&nbsp;<button type='button' class='btn btn-outline btn-info m-r-15 btn-sm' style='margin-lef: 10%' id='desel_all_chart_sta'> <i class='fa fa-chain-broken fa-fw'></i>  Deselect All</button></div> </div>",
            afterInit: function (ms) {
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function (e) {
                        if (e.which === 40) {
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function (values) {
                this.qs1.cache();
            },
            afterDeselect: function (values) {
                this.qs1.cache();
            }
        });

        var html = '';
        for(var i in chart_stations) {
            var string= chart_stations[i].split('(');
            html += '<option value="' + string[0].trim() + '">' + chart_stations[i] + '</option>';
        }
        $('#chart_stations').html(html).multiSelect('refresh');

        $('#sel_all_chart_dayparts').on('click', function (e) {
            $('#chart_age').multiSelect('select_all');
        });
        $('#desel_all_chart_dayparts').on('click', function (e) {
            $('#chart_age').multiSelect('deselect_all');
        });
        $('#sel_all_chart_sta').on('click', function (e) {
            $('#chart_stations').multiSelect('select_all');
        });
        $('#desel_all_chart_sta').on('click', function (e) {
            $('#chart_stations').multiSelect('deselect_all');
        });

        $('#graphsOptionsModal').modal('show');
    });
    $('#submit_charts_options').on('click', function(){
        if($('#chart_type option:selected').val() == ''){
            swal({
                    title: "Warning",
                    text: "Select Chart Type first...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else if($('#chart_demo_options').val().length == 0){
            swal({
                    title: "Warning",
                    text: "Select at least one Demo...",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else if($('#chart_age').val().length == 0){
            swal({
                    title: "Warning",
                    text: 'Select at least one Age Range',
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else if($('#chart_stations').val().length == 0){
            swal({
                    title: "Warning",
                    text: 'Select at least one Station..',
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "btn-danger",
                    confirmButtonText: "OK",
                    cancelButtonText: "Close",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {

                });
        }
        else {
            show_overlay_loader('#graphsOptionsModal .modal-content');
            var age_charts = $('#chart_age').val();
            var st_charts =  $('#chart_stations').val();
            var data_type = 'Impressions';
            var demo_type = $('#chart_demo_options').val();

            console.log('vendor_charts', age_charts);
            console.log('demo_type', demo_type);
            var results=[];
            var results_base=[];
            for(var y in st_charts) {
                results[st_charts[y]] = [];
                results_base[st_charts[y]] = [];

            }
            console.log('results', results);
            var thousands_total = 0;
            var table= $('#ratings_radio_market_comp_table ').DataTable();
            var st='';
            table.rows().eq(0).each( function ( index ) {
                var row = table.row( index );
                var data = row.data();
                if(data.gender == 'P')
                    st= data.station;
                if(data['gender'] == demo_type && st_charts.indexOf(st) !== -1){
                    for(var i in age_charts){
                        results[st][age_charts[i]] = (data[age_charts[i]].impressions == '')? 0 : parseFloat(data[age_charts[i]].impressions);
                        thousands_total += (data[age_charts[i]].impressions == '')? 0 : parseFloat(data[age_charts[i]].impressions);
                        results_base[st][age_charts[i]] = (data.base == '')? 0 : parseFloat(data.base);
                    }
                }
            });
            var format= '';
            console.log('results', results);

            if ($('#chart_type option:selected').val() == 'column' || $('#chart_type option:selected').val() == 'bar') {
                var series=[];
                for(var demo in results){
                    var data=[];
                    for(var age in results[demo]){
                        // perc= parseFloat( Number(Math.round(((Math.round(parseFloat(results[demo][age])/100) / Math.ceil(parseFloat(results_base[demo][age])/100)) * 100) +'e1')+'e-1'));
                        // data.push({
                        //     name:$('#chart_demo_options option:selected').val()+' '+ age,
                        //     y: parseFloat(parseFloat(results[demo][age]) / 100),
                        //     percentage: perc,
                        //     drilldown: null,
                        // });
                        var perc= parseFloat( Number(Math.round(((Math.round(parseFloat(results[demo][age])/100) / Math.ceil(parseFloat(results_base[demo][age])/100)) * 100) +'e1')+'e-1'));

                        if($('#chart_data_type option:selected').val() == 'both') {
                            data.push({
                                name: $('#chart_demo_options option:selected').val()+' '+ age,
                                y: parseFloat(parseFloat(results[demo][age]) / 100),
                                percentage: parseFloat(perc),
                                drilldown: null,
                            });
                        }
                        else if($('#chart_data_type option:selected').val() == 'impressions'){
                            data.push({
                                name: $('#chart_demo_options option:selected').val()+' '+ age,
                                y: parseFloat(parseFloat(results[demo][age]) / 100),
                                // percentage: parseFloat(perc),
                                drilldown: null,
                            });
                        }
                        else{
                            data.push({
                                name: $('#chart_demo_options option:selected').val()+' '+ age,
                                y: parseFloat(perc),
                                drilldown: null,
                            });
                        }

                    }
                    series.push({
                        name: demo,
                        data: data,
                    });
                }
                console.log('series', series)
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                Highcharts.setOptions(Highcharts.theme);
                var format = '';
                if($('#chart_data_type option:selected').val() == 'both')
                    format = '<b>{point.y:.0f}  </b>({point.percentage:.1f}%)';
                else if($('#chart_data_type option:selected').val() == 'impressions')
                    format = '<b>{point.y:.0f} </b>';
                else
                    format = '<b>{point.y:.1f} % </b>';

                var dt_type= '';
                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type = $('#chart_data_type option:selected').html();
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type = $('#chart_data_type option:selected').html();
                else
                    dt_type = 'Hundreds (00) & Percent (%)';
                Highcharts.chart('container_graphs', {
                    chart: {
                        type: $('#chart_type option:selected').val(),
                    },
                    title: {
                        text: $('#market').html()+' ; '+ $('#books').html(),
                    },
                    subtitle:{
                        text:  $('#form_day_part_day_part option:selected').html() +' ( ' + $('#day_part').html() + ' )',
                    },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: dt_type,
                        },
                        min: 0,
                    },
                    credits: {
                        text: 'GaleForce Digital, Inc.',
                    },
                    plotOptions: {
                        column: {
                            pointPadding: 0.2,
                            borderWidth: 0,
                            //  stacking: 'percent'
                        }
                    },
                    tooltip: {
                        headerFormat: '<span style="font-size:10px"><b>{point.key}</b></span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:5px"><b>'+ format +'</td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true,
                    },
                    series: series,
                });
            }
            else{
                var series = [];
                var data2 = [];

                for(var demo in results){
                    var total = 0;
                    var arr= [];
                    var cont=0;
                    var total_age= 0;
                    for(var age in results[demo]){
                        total += parseFloat(results[demo][age]);
                        total_age = parseFloat(results[demo][age]);
                        //arr.push([$('#chart_demo_options option:selected').val()+' '+age, parseFloat(total_age)/100]);
                        var perc= parseFloat( Number(Math.round(((Math.round(parseFloat(results[demo][age])/100) / Math.ceil(parseFloat(results_base[demo][age])/100)) * 100) +'e1')+'e-1'));
                        arr.push({name: age, y: parseFloat(total_age)/1000, x: perc, drilldown: null});
                        cont++;
                    }
                    data2.push({
                        name: demo,
                        id: demo,
                        data: arr,
                    });
                    var percent = 0;
                    percent= (thousands_total > 0) ? parseFloat(((parseFloat(total ) * 100) / thousands_total)).toFixed(2) : 0;
                    console.log('percent ', percent);
                    console.log('thousands_total ', thousands_total);
                    console.log('total ', total);
                    series.push({
                        name: demo,
                        y: total / 100,
                        x: percent,
                        drilldown: demo,
                    });

                    // series.push({
                    //     name: demo,
                    //     y: total / 100,
                    //     drilldown: demo,
                    // });
                }
                console.log('data2', data2);
                console.log('series', series)
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"],
                }
                Highcharts.setOptions(Highcharts.theme);
                var format = '';
                if($('#chart_data_type option:selected').val() == 'both')
                    format = '<b>{point.y:.0f}  </b>({point.x:.1f}%)';
                else if($('#chart_data_type option:selected').val() == 'impressions')
                    format = '<b>{point.y:.0f} </b>';
                else
                    format = '<b>{point.x:.1f} % </b>';

                var dt_type= '';
                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type = $('#chart_data_type option:selected').html();
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type = $('#chart_data_type option:selected').html();
                else
                    dt_type = 'Thousands (000) & Percent (%)';

                if($('#chart_data_type option:selected').val() == 'impressions')
                    dt_type_name = "Thousands";
                else if($('#chart_data_type option:selected').val() == 'per')
                    dt_type_name = "Percent"
                else
                    dt_type_name = 'Thousands & Percent';
                Highcharts.chart('container_graphs', {
                    chart: {
                        type: $('#chart_type option:selected').val(),
                    },
                    title: {
                        text:$('#market').html()+' ; '+ $('#books').html(),
                    },
                    subtitle:{
                        text:    $('#form_day_part_day_part option:selected').html() +' ( ' + $('#day_part').html() + ')<br> <span style="color: red"> Click the slices to view  '+ dt_type +' by Age Range. </span>',
                    },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: dt_type,
                        },
                        min: 0,
                    },
                    credits: {
                        text: 'GaleForce Digital, Inc.',
                    },
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true,
                                // format: '${point.y:.2f}'
                            },
                            showInLegend: true,
                        }
                    },
                    tooltip: {
                        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                            '<td style="padding:5px"><b>'+ format +' </b></td></tr>',
                        footerFormat: '</table>',
                        shared: true,
                        useHTML: true
                    },
                    series: [
                        {
                            name: 'Station',
                            colorByPoint: true,
                            data: series
                        }
                    ],
                    drilldown: {
                        series: data2
                    }
                });
            }

            $('#GraphsModal').modal('show');
            hide_overlay_loader('#graphsOptionsModal .modal-content');
        }
    });

    $(document).ready(function(){
        show_loader();
        dayPartInputInit('06:00', '15:00', 'radio');

        $.ajax({
            type: "GET",
            url: (location.href.indexOf('ratings/radio/composition/market') >= 0) ? '/ratings/radio/markets' : '/ratings/eastlan-radio/markets',
            dataType: 'json',
            success: function (data) {
                console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ data markets');
                console.log(data);
                data = collect(data).sortBy('name').all();

                var input = $('#form_market');

                input.html('').append('<option value=""></option>');
                $.each(data, function (index, value) {
                    input.append('<option value="' + value['code'] + '">' + value['name'] + '</option>')
                });

                input.select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10
                }).bind('change', function () {
                    ratingsRadioCompMarketOnMarketChange(this);
                });

                $('#form_geography').select2({
                    minimumResultsForSearch: 10
                }).bind('change', function () {
                    form_curr_area = $(this).val();
                    $(this).attr('disabled', 'disabled');
                });

                $('#form_stations').multiSelect(searchableMultiSelectDef);

                $('#form_books').multiSelect(searchableMultiSelectDef);

                $('#form_reset').bind('click', function(){
                    ratingsRadioCompMarketReset();
                });

                $('#form_submit').bind('click', function(){
                    chart_stations = []
                    $('#form_stations option:selected').each(function () {
                        chart_stations[$(this).val()] = $(this).html();
                    });
                    ratingsRadioCompMarketSubmit();
                });

                form_markets = data;

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
            }
        });
    });

    var ratingsRadioCompMarketOnMarketChange = function(select){
        show_loader();
        form_curr_market = collect(form_markets).where('code', parseInt($(select).val())).first();
       // console.log('asdasdasdasdasdasdasddssssssssssssssssssssssssssssssssss');
        console.log(form_curr_market);

        var input = $('#form_geography');

        input.val('Metro').trigger("change");
        if(form_curr_market['type'] === 'PPM'){
            input.attr('disabled', 'disabled');
            input.closest('.form-group').find('.help-text').removeClass('hidden');
        }else{
            input.attr('disabled', null);
            input.closest('.form-group').find('.help-text').addClass('hidden');
        }

        $.ajax({
            type: "GET",
            url: '/ratings/radio/books/?code=' + $(select).val(),
            dataType: 'json',
            success: function (data) {
                var input = $('#form_books');

                var html = '';
                if(form_curr_market['frequency'] === 13){
                    form_curr_book_limit = 13;
                    html = 'Books will be averaged. Maximum of Thirteen.<span class="pull-right"><small><span class="select-count text-muted">(0 / 13)</span></small></span>';
                }else if(form_curr_market['frequency'] === 4){
                    form_curr_book_limit = 4;
                    html = 'Books will be averaged. Maximum of Four.<span class="pull-right"><small><span class="select-count text-muted">(0 / 4)</span></small></span>';
                }else{
                    form_curr_book_limit = 1;
                    html = 'Maximum of One.<span class="pull-right"><small><span class="select-count text-muted">(0 / 1)</span></small></span>';
                }

                $('.form-books-container').find('.text-default').html(html);

                input.attr('disabled', null);
                input.multiSelect('destroy');

                input.html('');
                // $.each(data, function (index, value) {
                //     input.append('<option value="' + value['id'] + '">' + value['name'] + '</option>')
                // });
                var dates_ordered= data;
                var OrdDates= Object.entries(dates_ordered).sort((a,b) => (a[1].end > b[1].end) ? 1 : ((b[1].end > a[1].end) ? -1 : 0));

                var cont = OrdDates.length - 1;
                while(cont >= 0){
                    var value= OrdDates[cont][1];
                    input.append('<option value="' + value['id'] + '">' + value['name'] + '</option>')
                    cont--;
                }

                input.multiSelect({
                    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                    afterInit: function(ms){
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function(e){
                                if (e.which === 40){
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                    },
                    afterSelect: function(values){
                        this.qs1.cache();

                        form_curr_books = this.$element.val();
                        if(this.$element.val().length <= form_curr_book_limit){
                            ratingsCompMarketOnBooksChange();
                        }else{
                            form_curr_books = this.$element.val();
                            this.$element.multiSelect('deselect', values);

                            swal({
                                    title: "Warning",
                                    text: "The max number is "+ form_curr_book_limit +"...",
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "OK",
                                    cancelButtonText: "Close",
                                    closeOnConfirm: true,
                                    closeOnCancel: true
                                },
                                function (isConfirm) {

                                });
                        }

                        if(form_curr_books.length < form_curr_book_limit){
                            this.$element.closest('.form-books-container').find('.select-count').html('(' + form_curr_books.length + ' / ' + form_curr_book_limit + ')').removeClass('text-warning').addClass('text-muted');
                        }else{
                            this.$element.closest('.form-books-container').find('.select-count').html('(' + form_curr_books.length + ' / '  + form_curr_book_limit + ')').removeClass('text-muted').addClass('text-warning');
                        }
                    },
                    afterDeselect: function(values){
                        this.qs1.cache();

                        form_curr_books = this.$element.val();
                        if(form_curr_books.length > 0){
                            ratingsCompMarketOnBooksChange();
                        }else{
                            ratingsRadioCompMarketReset(2);
                        }

                        this.$element.closest('.form-books-container').find('.select-count').html('(' + form_curr_books.length + ' / 4)').removeClass('text-warning').addClass('text-muted');

                    }
                });

                input.closest('.form-books-container').removeClass('hidden');
                input.closest('.form-books-container').parent().find('.help-text').addClass('hidden');

                ratingsRadioCompMarketReset(2);

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
            }
        });
    };


    var ratingsCompMarketOnBooksChange = function(select){

        var parameters = '?';
        $.each(form_curr_books, function (index, value) {
            parameters += 'books[]=' + value + '&';
        });
        var url = '/ratings/radio/books/stations/' + parameters + '&area=' + form_curr_area;

        show_loader();
        $.ajax({
            type: "GET",
            url: url,
            dataType: 'json',
            success: function (data) {
                var input = $('#form_stations');

                input.attr('disabled', null);
                input.multiSelect('destroy');

                input.html('');
                $.each(data, function (index, value) {
                    input.append('<option value="' + value['id'] + '">' + value['name'] + '</option>')
                });

                input.multiSelect({
                    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                    afterInit: function(ms){
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function(e){
                                if (e.which === 40){
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                    },
                    afterSelect: function(values){
                        this.qs1.cache();

                        form_curr_stations = this.$element.val();
                        $('#form_submit').attr('disabled', null);
                        if(this.$element.val().length > 20){
                            this.$element.multiSelect('deselect', values);
                            form_curr_stations = this.$element.val();

                            swal({
                                    title: "Warning",
                                    text: "The limit of Stations is 20...",
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "OK",
                                    cancelButtonText: "Close",
                                    closeOnConfirm: true,
                                    closeOnCancel: true
                                },
                                function (isConfirm) {

                                });
                        }

                        if(form_curr_stations.length < 20){
                            this.$element.closest('.form-stations-container').find('.select-count').html('(' + form_curr_stations.length + ' / 20)').removeClass('text-warning').addClass('text-muted');
                        }else{
                            this.$element.closest('.form-stations-container').find('.select-count').html('(' + form_curr_stations.length + ' / 20)').removeClass('text-muted').addClass('text-warning');
                        }
                    },
                    afterDeselect: function(values){
                        this.qs1.cache();

                        form_curr_stations = this.$element.val();
                        if(form_curr_stations.length === 0){
                            $('#form_submit').attr('disabled', 'disabled');
                        }
                        this.$element.closest('.form-stations-container').find('.select-count').html('(' + form_curr_stations.length + ' / 20)').removeClass('text-warning').addClass('text-muted');
                    }
                });

                if(typeof form_curr_stations !== 'undefined'){
                    if(form_curr_stations.length > 0){
                        input.multiSelect('select', form_curr_stations);
                        input.multiSelect('refresh');
                        form_curr_stations = input.val();
                    }
                }


                input.closest('.form-stations-container').removeClass('hidden');
                input.closest('.form-stations-container').parent().find('.help-text').addClass('hidden');

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                hide_loader();
            }
        });
    };

    var ratingsRadioCompMarketSubmit = function(){
        books = $('#form_books').val();
        console.log('***********************************bookks');
        console.log(books);
        console.log($('#form_books').val());
        stations = $('#form_stations').val();
        area = $('#form_geography').val();

        dp_start = moment($('#form_day_part_start').val(), 'h:mm A');
        dp_end = moment($('#form_day_part_end').val(), 'h:mm A');

        day_part = $('#form_day_part_days').val() + dp_start.format('HHmm') + dp_end.format('HHmm');

        console.log("request");
        console.log($.param({
            day_part: day_part,
            books: books,
            stations: stations,
            area: area
        }));

        show_loader();
        $.ajax({
            url: '/ratings/radio/books/composition/market?' + $.param({
                day_part: day_part,
                books: books,
                stations: stations,
                area: area
            }),
            dataType: 'json',
            type : 'GET',
            success: function (data) {
                console.log(data);
                table_data = [];

                books_html = '';
                market_html = '';

                $.each(data['books'], function(index, value){
                    if(index === 0){
                        market_html = value['market']['name'] + ' ' + value['market']['type'] + ' ';
                        if(value['market']['type'] === 'PPM'){
                            market_type = 'PPM';
                            $('#nielsen-disclaimer').find('.ppm-disclaimer').removeClass('hidden');
                        }else{
                            market_type = 'Diary';
                            $('#nielsen-disclaimer').find('.ppm-disclaimer').addClass('hidden');
                        }
                    }

                    books_html += value['period_name'];

                    if(index !== (data['books'].length - 1)){
                        books_html += '/';
                    }
                });

                $.each(data['data'], function(index, value){
                    console.log("aquiii");
                     if(typeof value["6-11"] === 'undefined'){
                         console.log("entro");
                         data['data'][index]["6-11"] = {
                             'P': { 'impressions': 0, 'intab' : true },
                             'M': { 'impressions': 0, 'intab' : true },
                             'F': { 'impressions': 0, 'intab' : true }
                         };
                     }
                    if(typeof value["45-54"] === 'undefined'){
                        console.log("entro");
                        data['data'][index]["45-54"] = {
                            'P': { 'impressions': 0, 'intab' : true },
                            'M': { 'impressions': 0, 'intab' : true },
                            'F': { 'impressions': 0, 'intab' : true }
                        };
                    }
                });
                console.log(data['data']);

                $('#market').html(market_html);
                $('#books').html(books_html);
//                    $('#station').html(data['station']['name'] + ' (' + data['station']['frequency']+ ')');
                $('#day_part').html(ratingsHumanDaypart(day_part));
                $('#area').html(area);

                $.each(data['data'], function(index, value){

                    if(market_type === 'PPM'){
                        p_base = value['6+']['P']['impressions'];
                        m_base = value['6+']['M']['impressions'];
                        f_base = value['6+']['F']['impressions'];
                        $('#base_demo_header').html('6+');
                    }else{
                        p_base = value['12+']['P']['impressions'];
                        m_base = value['12+']['M']['impressions'];
                        f_base = value['12+']['F']['impressions'];
                        $('#base_demo_header').html('12+');
                    }

                    var gender_data = {
                        'P': {},
                        'M': {},
                        'F': {}
                    };


                    $.each(value, function(index, value){
                        if($.inArray(index, ['6+', '12+']) === -1){
                            var curr_age = index;
                            $.each(value, function(index, value){
                                gender_data[index][curr_age] = value;
                            });
                        }
                    });

                    var push = {
                        station: index,
                        gender: "P",
                        base: p_base
                    };

                    $.each(gender_data['P'], function(index, value){
                        push[index] = {
                            impressions: value['impressions'],
                            intab: value['intab']
                        }
                    });

                    table_data.push(push);

                    var push = {
                        station: index,
                        gender: "M",
                        base: p_base
                    };

                    $.each(gender_data['M'], function(index, value){
                        push[index] = {
                            impressions: value['impressions'],
                            intab: value['intab']
                        }
                    });

                    table_data.push(push);

                    var push = {
                        station: index,
                        gender: "F",
                        base: p_base
                    };

                    $.each(gender_data['F'], function(index, value){
                        push[index] = {
                            impressions: value['impressions'],
                            intab: value['intab']
                        }
                    });

                    table_data.push(push);
                });

                console.log("table");
                console.log(table_data);
                var imp=0;
                $.each(table_data, function(index, value){
                   // if(value.indexOf('rating_primary_') !== -1)
                    if(typeof value['45-49'] !=='undefined')
                        value['45-54'].impressions+= parseFloat(value['45-49'].impressions)
                    if(typeof value['50-54'] !=='undefined')
                        value['45-54'].impressions+= parseFloat(value['50-54'].impressions)

                });
                  console.log('table after');
                  console.log(table_data);
                var columns;

                if(market_type === 'PPM'){
                    $('#column_to_show').show();
                    hide_one=8;
                    hide_two=9;
                  //  var export_colums='"Station","","6+", 6-11, 12-17,"18-24","25-34","35-44","45-49","50-54","45-54","55-64","65+"';
                    var export_colums='"Station","","6+", 6-11, 12-17,"18-24","25-34","35-44","45-54","55-64","65+"';
                    columns = [
                        {
                            data: "station"//0
                        },{
                            data: "gender"//1
                        },{
                            data: "base"//2
                        },{
                            data: "6-11"//3
                        },{
                            data: "12-17"//4
                        },{
                            data: "18-24"//5
                        },{
                            data: "25-34"//6
                        },{
                            data: "35-44"//7
                        },{
                            data: "45-49"//8
                        },{
                            data: "50-54"//9;
                        },
                        {
                            data: "45-54"//10
                        },{
                            data: "55-64"//11
                        },{
                            data: "65+"//12
                        }
                    ];
                }else{
                    $('#column_to_show').hide();
                    hide_one=7;
                    hide_two=8;
                   // var export_colums='"Station","",12+, 12-17,18-24,"25-34","35-44","45-49","50-54","45-54","55-64","65+"'
                    var export_colums='"Station","",12+, 12-17,18-24,"25-34","35-44","45-54","55-64","65+"'
                    columns = [
                        {
                            data: "station"//0
                        },{
                            data: "gender"//1
                        },{
                            data: "base"//2
                        },{
                            data: "12-17"//3
                        },{
                            data: "18-24"//4
                        },{
                            data: "25-34"//5
                        },{
                            data: "35-44"//6
                        },{
                            data: "45-49"//7
                        },{
                            data: "50-54"//8
                        },
                        {
                            data: "45-54"//9
                        },{
                            data: "55-64"//10
                        },{
                            data: "65+"//11
                        }
                    ];
                }


                var dt_options = {
                    columns: columns,
                    "columnDefs": [
                        {
                            "orderable": false,
                            "targets": '_all',
                        },
                        {
                            "targets":hide_one ,
                            "visible": false,

                        },{
                            "targets":hide_two ,
                            "visible": false,

                        },
                        {
                            "render": function ( data, type, row, meta ) {
                                if(meta['col'] > 1){
                                    if(meta['col'] === 2){
                                        data = Math.floor(data / 1000).toLocaleString("en-US", {
                                            minimumFractionDigits: 0
                                        });
                                    }else{
                                        if(data['impressions'] !== ''  ){
                                            var html = '<div class="left">' + Number(Math.round((data['impressions'] / 100) +'e0')+'e-0').toLocaleString("en-US", {
                                                minimumFractionDigits: 0
                                            });
                                            if(! data['intab']){
                                                curr_intab = true;
                                                html += '<span class="intab-indicator">&nbsp;✝</span>'
                                            }
                                            if(row['base'] !== null && row['base'] !== '' && row['base'] !== 0)
                                              html += '</div><div class="right"><span style="font-weight: 400;">(' + Number(Math.round(((Math.round(data['impressions']/100) / Math.ceil(row['base']/100)) * 100) +'e1')+'e-1').toString() + '%)</span></div>';
                                            else
                                               html += '</div><div class="right"><span style="font-weight: 400;">(0%)</span></div>';

                                            data = html;
                                        }else{
                                            data = '';
                                        }
                                    }
                                }

                                return data;
                            },
                            "targets": '_all'
                        },{
                            "width": "10%",
                            "targets": 'demo'
                        }
                    ],
                    "order": [],
                    dom: 'Bfrtip',
                    buttons: [
                      //  'copy', 'csv', 'excel', 'print'
                        'copy',
                        {
                            extend: 'excel',
                            messageTop: market_html+' > '+ books_html+' > '+area+' > '+ratingsHumanDaypart(day_part),
                            exportOptions: {
                                columns: ':visible'
                            }
                        },
                        {
                            extend: 'csv',
                            messageTop: market_html+' > '+ books_html+' > '+area+' > '+ratingsHumanDaypart(day_part),
                            exportOptions: {
                                columns: ':visible'
                            },
                            customize: function (csv) {
                                //Split the csv to get the rows
                                var split_csv = csv.split("\n");

                                split_csv[0] = export_colums;
                              var html_header= '"",'+ market_html+' > '+ books_html+' > '+area+' > '+ratingsHumanDaypart(day_part);
                              split_csv[0]='"","","",Radio Ratings Market Composition - Galeforcemedia'+ "\n"+html_header+ "\n" + split_csv[0];


                                csv = split_csv.join("\n");
                                return csv;
                            }
                        },
                        {
                            extend: 'print',
                            messageTop:  market_html+' > '+ books_html+' > '+area+' > '+ratingsHumanDaypart(day_part),
                            exportOptions: {
                                columns: ':visible'
                            }
                        },
                    ],
                    "searching": false,
                    "paging": false,
                    "info": false,
                    data: table_data
                };

                if(typeof dt !== 'undefined'){
                    dt.destroy();
                    $('#ratings_radio_market_comp_table').find('tbody').empty();
                }

                dt = $('#ratings_radio_market_comp_table').DataTable( dt_options );

                if($('.ratings-table-container').hasClass('hidden')){
                    $('.ratings-table-container').removeClass('hidden');
                }

                $('#radio_comp_market_generate_panel').find('div.clickable').click();


                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
            }
        });
    };

    var ratingsRadioCompMarketReset = function(step){
        if(typeof step === 'undefined'){
            step = 'all';
        }

        if(step === 'all') {
            var input = $('#form_market');

            input.html('').append('<option value=""></option>');
            $.each(form_markets, function (index, value) {
                input.append('<option value="' + value['code'] + '">' + value['name'] + '</option>')
            });

            input.select2({
                placeholder: "Select one...",
                minimumResultsForSearch: 10
            }).bind('change', function () {
                ratingsRadioCompMarketOnMarketChange(this);
            });
        }

        if((step < 2) || (step === 'all')){
            input = $('#form_books');

            input.multiSelect('destroy');
            input.html('');
            input.multiSelect(searchableMultiSelectDef);
            input.closest('.form-books-container').addClass('hidden');
            input.closest('.form-books-container').parent().find('.help-text').removeClass('hidden');

            input = $('#form_geography');
            input.val('Metro').trigger("change");
            input.attr('disabled', 'disabled');
            input.closest('.form-group').find('.help-text').addClass('hidden');
        }

        if((step < 3) || (step === 'all')){
            input = $('#form_stations');

            input.multiSelect('destroy');
            input.html('');
            input.multiSelect(searchableMultiSelectDef);
            input.closest('.form-stations-container').addClass('hidden');
            input.closest('.form-stations-container').parent().find('.help-text').removeClass('hidden');

            $('#form_submit').attr('disabled', 'disabled');
        }
    };
};
